export const SET_INVENTORIES = 'SET_INVENTORIES'
export const SET_TOLERANCES = 'SET_TOLERANCES'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_BRANDS = 'SET_BRANDS'



// WEBPACK FOOTER //
// ./src/types/inventory.js